import React, { ReactElement } from "react";
import "src/styles/SampleDetails.css";
import { Tooltip } from "@mui/material";
import { useSampleDetails } from "src/common/hooks/useSampleDetails";
import { SampleDetailsContent } from "src/common/components/SampleDetailsContent";

export type SampleDetailsProps = {
  sampleId: number;
  children: ReactElement;
  onClose?: () => void;
};

const SampleDetails = ({ sampleId, children }: SampleDetailsProps) => {
  const [{ loading, sample, loadingDots }, loadData] = useSampleDetails();

  const dotsString = '.'.repeat(loadingDots);

  const handleOpen = () => {
    loadData(sampleId);
  };

  const renderTooltipContent = () => {
    if (loading) {
      return `Loading${dotsString}`;
    }
    return <SampleDetailsContent data={sample} />;
  };

  return (
    <Tooltip
      classes={{
        tooltip: "sample-details-tooltip",
      }}
      onOpen={handleOpen}
      enterDelay={300}
      leaveDelay={300}
      title={renderTooltipContent()}
    >
      {children}
    </Tooltip>
  );
};

export default SampleDetails;